module.exports = require("@swa-ui/core/src/DateSelector/Day.module.scss");